import { render, staticRenderFns } from "./noticeItem.vue?vue&type=template&id=2ca9c52c&scoped=true"
import script from "./noticeItem.vue?vue&type=script&lang=js"
export * from "./noticeItem.vue?vue&type=script&lang=js"
import style0 from "./noticeItem.vue?vue&type=style&index=0&id=2ca9c52c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca9c52c",
  null
  
)

export default component.exports